// API 配置
export const API_CONFIG = {
    // 基础URL
    BASE_URL: process.env.VUE_APP_API_BASE_URL || 'http://localhost/api',
    
    // 超时时间
    TIMEOUT: 10000,
    
    // 请求头
    HEADERS: {
      'Content-Type': 'application/json',
    },
    
    // 是否启用调试
    DEBUG: process.env.NODE_ENV !== 'production',
    
    // 获取当前环境
    get ENV() {
      return process.env.NODE_ENV || 'development';
    },
    
    // 是否是生产环境
    get IS_PRODUCTION() {
      return this.ENV === 'production';
    }
  };